import { render, staticRenderFns } from "./LegalConsultant.vue?vue&type=template&id=8160c352&scoped=true"
import script from "./LegalConsultant.vue?vue&type=script&lang=js"
export * from "./LegalConsultant.vue?vue&type=script&lang=js"
import style0 from "./LegalConsultant.vue?vue&type=style&index=0&id=8160c352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8160c352",
  null
  
)

export default component.exports